import { RouteRecordRaw, RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { validateIdAsPositiveIntegerGuard } from '@/router/routeGuards';
import { useAuthStore } from '@/stores';
import { Permission } from '@/types';
import WhatsappCodeListPage from '@/views/pages/whatsapp-code/WhatsappCodeListPage.vue';
import WhatsappCodeMonitorPage from '@/views/pages/whatsapp-code/WhatsappCodeMonitorPage.vue';

const checkPermissionAndFeature = (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext,
) => {
    const authStore = useAuthStore();
    const hasPermission = authStore.userPermissions.includes(Permission.VIEW_WHATSAPP_CODES);

    if (hasPermission) {
        next();
    } else {
        next({ name: 'Home' });
    }
};

const whatsappCodeRouter: RouteRecordRaw = {
    name: 'WhatsappCode',
    path: 'whatsapp-codes',
    children: [
        {
            name: 'ListWhatsappCodeNumbers',
            path: '',
            component: WhatsappCodeListPage,
            beforeEnter: [checkPermissionAndFeature],
            meta: { isLevelLocked: true },
        },
        {
            name: 'MonitorWhatsappCodeNumber',
            path: ':id/monitor',
            component: WhatsappCodeMonitorPage,
            beforeEnter: [validateIdAsPositiveIntegerGuard, checkPermissionAndFeature],
            meta: { isLevelLocked: true },
        },
    ],
};

export default whatsappCodeRouter;
